interface PersonaDiscountCommentsProps {
  comments?: string[];
  title?: string;
  className?: string;
}

/**
 * Shared "Persona Discount" callout rendered as a yellow highlighted area.
 * Used by the cart appointment comments card and the patient waiting list.
 */
const PersonaDiscountComments = ({
  comments = [],
  // title = "Persona Discount",
  className = "",
}: PersonaDiscountCommentsProps) => {
  if (!comments?.length) return null;

  return (
    <div className={`bg-yellow-50 border border-yellow-300 my-2 p-3 rounded-xl ${className}`}>
      {/* <p className="font-medium text-xs text-yellow-800 mb-1">{title}</p> */}
      <ul className="space-y-1 pl-3 list-disc">
        {comments.map((text, index) => (
          <li key={index} className="font-medium text-yellow-900 text-xs break-words whitespace-normal">
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PersonaDiscountComments;
